export const REGEXP = {
  BOOK_DETAIL_PAGE: /\/book\/.+\/detail/,
  BOOK_EDIT_PAGE: /\/book\/.+\/edit/,
};
